import { Popover as HeadlessPopover } from "@headlessui/react"
import { PopoverPanel } from "shared-web/components/base/overlay/Popover"

import PopoverMenuButton from "./PopoverMenuButton"
import PopoverMenuCombobox from "./PopoverMenuCombobox"
import {
  PopoverMenuButtonProps,
  PopoverMenuButtonVariants,
  PopoverMenuProps,
} from "./types"

function PopoverMenu(props: PopoverMenuProps) {
  const { items, onSelect, onChangeQuery, className, style } = props

  const popoverMenuButtonProps: PopoverMenuButtonProps = (() => {
    switch (props.buttonVariant) {
      case PopoverMenuButtonVariants.Icon:
        return {
          buttonVariant: props.buttonVariant,
          icon: props.icon,
          buttonMode: props.buttonMode,
          buttonSize: props.buttonSize,
        }
      case PopoverMenuButtonVariants.Text:
        return {
          buttonVariant: props.buttonVariant,
          buttonTitle: props.buttonTitle,
        }
      default:
        return {
          buttonVariant: props.buttonVariant,
          buttonMode: props.buttonMode,
          buttonLeftIcon: props.buttonLeftIcon,
          buttonTitle: props.buttonTitle,
          buttonSize: props.buttonSize,
        }
    }
  })()

  return (
    <HeadlessPopover className={className} style={style}>
      <PopoverMenuButton {...popoverMenuButtonProps} />
      <PopoverPanel>
        <PopoverMenuCombobox
          items={items}
          onSelect={onSelect}
          onChangeQuery={onChangeQuery}
        />
      </PopoverPanel>
    </HeadlessPopover>
  )
}

export default PopoverMenu
